<template>
  <section class="hero" id="top">
    <div class="wrap hero-inner">
      <div>
        <span class="eyebrow">
          <span class="dot"></span>
          {{ labelsState['lv_hero_eyebrow'] || 'Platform #1 in LATAM · 2026' }}
        </span>
        <div class="hero-heading-gap"></div>
        <h1 class="grad-text">
          {{ labelsState['banner_title'] || 'Virtual assistants that actually sell.' }}
          <small>{{ labelsState['create_yout_chat'] || 'WhatsApp, Instagram, Messenger and web. Ready in 3 minutes.' }}</small>
        </h1>
        <p class="hero-sub">{{ labelsState['lv_hero_sub'] || 'NQA connects your business with conversational AI trained on your data. Responds, schedules, sells and escalates to a human when needed. No code.' }}</p>
        <div class="hero-cta">
          <a class="btn btn-primary btn-lg" :href="registerUrl" target="_blank">
            {{ labelsState['start_free_now'] || 'Try free for 14 days' }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
              <path d="M5 12h14M13 5l7 7-7 7"/>
            </svg>
          </a>
          <a class="btn btn-ghost btn-lg" href="#producto">{{ labelsState['lv_hero_cta_ghost'] || 'See how it works' }}</a>
        </div>
        <div class="hero-trust">
          <div class="avatars">
            <span style="background: linear-gradient(135deg,#00cc99,#2563eb)">JS</span>
            <span style="background: linear-gradient(135deg,#2563eb,#7c3aed)">MV</span>
            <span style="background: linear-gradient(135deg,#22d3ee,#00cc99)">RT</span>
            <span style="background: linear-gradient(135deg,#7c3aed,#2563eb)">AL</span>
          </div>
          <span>
            <strong style="color:var(--t-0)">{{ labelsState['lv_hero_trust_count'] || '+ 2,400 companies' }}</strong>
            {{ labelsState['lv_hero_trust_text'] || 'automate their customer service with NQA' }}
          </span>
        </div>
      </div>
      <ChatDemoV2 />
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';
import ChatDemoV2 from './ChatDemoV2.vue';

export default {
  name: 'HeroV2',
  components: { ChatDemoV2 },
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();

    onMounted(() => {
      labelsStore.fetchAndSetLabels(languageStore.language);
    });

    return {
      labelsState: computed(() => labelsStore.labels),
      registerUrl: `${process.env.VUE_APP_DASHBOARD_URL}/auth/cover-register`,
    };
  },
};
</script>
